<template>
  <el-row class="user-grid">
    <el-col v-for="user in users" :key="user.id" :span="6">
      <div class="user-grid-item">
        <div>
          <user-avatar :userId="user.id" :factor="2.5"></user-avatar>
          <router-link
            :to="{ name: 'Profile', params: { id: user.id } }"
            class="user-grid-item-link"
            >{{ user.name }} <br />
            {{ user.surName }}
          </router-link>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import UserAvatar from "@/components/avatars/UserAvatar";

export default {
  props: {
    users: Array,
  },
  components: {
    "user-avatar": UserAvatar,
  },
};
</script>

<style>
.user-grid .user-grid-item {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}
.user-grid .user-grid-item-link {
  text-align: center;
  text-decoration: none;
  display: block;
  color: var(--textGeneralColor);
}
.user-grid .user-grid-item-link:hover {
  text-decoration: underline;
}
</style>